var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refresh-message-container",class:{
    'is-small': _vm.isSmall
  }},[_c('img',{staticClass:"refresh-button",attrs:{"alt":"Refresh button","src":_vm.refreshIcon},on:{"keydown":_vm.refresh,"click":_vm.refresh}}),_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }